<template>
  <div id="page-artificial-intelligence">
    <ContentHeader>
      <h6 class="header__meta-title">{{ $wp.metaTitle }}</h6>
      <h1 class="header__title">{{ $wp.header.title }}</h1>
      <h3 class="header__subtitle">
        <span class="header__subtitle-text">
          <Icon id="chat" class="header__subtitle-icon" />
          {{ $wp.header.subtitle }}
        </span>
      </h3>
    </ContentHeader>

    <ContentSplit id="intro" :title="$wp.intro.title" :image="$wp.intro.image">
      <ContentRaw :html="$wp.intro.content" />
    </ContentSplit>

    <ContentSection id="context" alt-background :title="$wp.context.title" content-class="-centered">
      <ContentRaw :html="$wp.context.content" />

      <ul class="row -spread discovery -push">
        <li v-for="item in $wp.context.items_items" :key="item.title" class="discovery__item">
          <figure class="discovery__image" :style="{ backgroundImage: `url(${item.image})` }" />
          <h4 class="discovery__title">{{ item.title }}</h4>
          <ContentRaw :html="item.content" />
        </li>
      </ul>
    </ContentSection>

    <ContentSection id="effects" align-left flat-title :title="$wp.effects.title">
      <div
        v-for="({ left, right }, index) in $wp.effects.rows"
        :key="left.title"
        class="row"
        :class="{ '-alt': index % 2 }"
      >
        <ContentRaw class="row__item -span-5" :html="left.content">
          <h3>{{ left.title }}</h3>
        </ContentRaw>

        <div class="row__item -span-6 -skip">
          <h3 class="section__subtitle -center-phone">{{ right.title }}</h3>

          <DiscoverySlider :slides="right.items_items" />
        </div>
      </div>
    </ContentSection>

    <ContentSection id="actors" :title="$wp.actors.title">
      <ContentRaw
        :html="{ before: $wp.actors.textTop, after: $wp.actors.textBottom }"
        class="-align-center -narrow-text"
      >
        <img :src="$wp.actors.image" />
      </ContentRaw>
    </ContentSection>

    <ContentSection :title="$wp.interventions.title">
      <div class="row -center -wrap">
        <article v-for="item in $wp.interventions.items" :key="item.title" class="card">
          <figure class="card__image" :style="{ backgroundImage: `url(${item.image})` }" />

          <div class="card__content">
            <div>
              <h5 class="card__title">{{ item.title }}</h5>
              <p>{{ item.text }}</p>
              <PageLink class="button -corner card__button" v-bind="item.link" :anchor-id="`#${item.anchorId}`" />
            </div>
          </div>
        </article>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import { DiscoverySlider } from '@/components/partials'
import { ContentSection, ContentSplit, ContentHeader, ContentRaw } from '@/components/content'

export default {
  name: 'ArtificialIntelligence',
  contentKey: 'ai',
  components: { DiscoverySlider, ContentSection, ContentSplit, ContentHeader, ContentRaw }
}
</script>
